// assets/validate-checkout.js
(function () {
  if (window.DRSingleItemCheckoutGuard) return;

  const DEBUG = true;
  const SHOP_ROOT =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  const CHECKOUT_PATH = SHOP_ROOT + "checkout";
  const STORAGE_KEY = "dr_latest_added_line_key_v1";

  function log(msg, data) {
    if (DEBUG) console.log("[DR checkout guard] " + msg, data || "");
  }

  function getLatestKey() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || "";
    } catch (error) {
      return "";
    }
  }

  function setLatestKey(key) {
    if (!key) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(key));
      log("Saved latest line key", key);
    } catch (error) {
      log("Could not save latest line key", error);
    }
  }

  function clearLatestKey() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function rememberFromAddResponse(payload) {
    if (!payload) return null;

    const items = Array.isArray(payload.items) ? payload.items : [payload];
    const latestItem = items[items.length - 1];

    if (latestItem && latestItem.key) {
      setLatestKey(latestItem.key);
      return latestItem.key;
    }

    return null;
  }

  async function getCart() {
    const res = await fetch(SHOP_ROOT + "cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!res.ok) {
      throw new Error("Could not read the cart.");
    }

    return res.json();
  }

  async function updateCartQuantities(quantities) {
    const res = await fetch(SHOP_ROOT + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates: quantities })
    });

    if (!res.ok) {
      let message = "Could not update the cart before checkout.";

      try {
        const data = await res.json();
        message = data.description || data.message || message;
      } catch (error) {}

      throw new Error(message);
    }

    return res.json();
  }

  async function clearCart() {
    const cart = await getCart();
    const items = Array.isArray(cart && cart.items) ? cart.items : [];

    if (!items.length) return cart;

    const quantities = items.map(() => 0);
    await updateCartQuantities(quantities);

    return getCart();
  }

  function findKeepIndex(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) return -1;

    const latestKey = getLatestKey();
    if (latestKey) {
      const exactIndex = items.findIndex((item) => item && item.key === latestKey);
      if (exactIndex !== -1) return exactIndex;
    }

    return items.length - 1;
  }

  function buildSingleItemQuantities(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) return null;

    const keepIndex = findKeepIndex(cart);
    if (keepIndex < 0) return null;

    return {
      keepIndex,
      keptItem: items[keepIndex],
      quantities: items.map((_, index) => (index === keepIndex ? 1 : 0))
    };
  }

  async function normalizeCartToSingleLatestItem() {
    const cart = await getCart();
    const items = Array.isArray(cart && cart.items) ? cart.items : [];

    if (!items.length) {
      return { empty: true, cart };
    }

    const payload = buildSingleItemQuantities(cart);
    if (!payload || !payload.keptItem) {
      return { empty: true, cart };
    }

    const alreadyNormalized =
      items.length === 1 &&
      items[0] &&
      items[0].key === payload.keptItem.key &&
      Number(items[0].quantity) === 1;

    if (alreadyNormalized) {
      return {
        empty: false,
        changed: false,
        cart,
        keptItem: payload.keptItem
      };
    }

    const updatedCart = await updateCartQuantities(payload.quantities);

    return {
      empty: false,
      changed: true,
      cart: updatedCart,
      keptItem: payload.keptItem
    };
  }

  async function directCheckoutAdd(form) {
    if (!(form instanceof HTMLFormElement)) {
      throw new Error("A valid form is required.");
    }

    // Hard guarantee:
    // clear cart -> add only submitted item qty 1 -> remember added line -> checkout
    await clearCart();

    const formData = new FormData(form);
    formData.set("quantity", "1");

    const response = await fetch(SHOP_ROOT + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      },
      body: formData
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {}

    if (!response.ok) {
      throw new Error(
        (payload && (payload.description || payload.message)) ||
          "Could not add the latest item before checkout."
      );
    }

    rememberFromAddResponse(payload);
    await normalizeCartToSingleLatestItem();
    window.location.href = CHECKOUT_PATH;
  }

  async function toCheckout() {
    const result = await normalizeCartToSingleLatestItem();

    if (result.empty) {
      window.location.href = SHOP_ROOT + "cart";
      return;
    }

    window.location.href = CHECKOUT_PATH;
  }

  window.DRSingleItemCheckoutGuard = {
    getCart,
    clearCart,
    getLatestKey,
    setLatestKey,
    clearLatestKey,
    rememberFromAddResponse,
    normalizeCartToSingleLatestItem,
    directCheckoutAdd,
    toCheckout
  };
})();